import { updateMovie } from '../../Graphql/mutations'
import AppSyncClient from '../../Utils/AppSyncClient'
// import { toast } from 'react-toastify'
const UpdateMovie = async parameters => {
  try {
    const data = await AppSyncClient.mutate({
      mutation: updateMovie,
      variables: parameters,
      fetchPolicy: 'no-cache',
    })
    // const toastStyle = {
    //   position: 'top-right',
    //   autoClose: 2000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // }

    // if (data.data.updateMovie.statusCode === 'A001') {
    //   toast.success(data.data.updateMovie.statusMessage, toastStyle)
    // } else {
    //   toast.error('Updated Movie unsuccessfully', toastStyle)
    // }
    //

    return data.data.updateMovie
  } catch (error) {
    return error
  }
}

export default UpdateMovie
